import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSonarObjectStakeholders } from '@api';
import { updateSonarObjectReferences } from '../_idMap/actions';

export const getCoreSonarObjectsStakeholdersSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateSonarObjectReferences([
					{
						sonarObjectId: request.sonarObjectId,
						stakeholders: response.map((stakeholder) => stakeholder.stakeholderId)
					}
				])
		]
	},
	name: 'CoreSonarObjectsStakeholders',
	receive: true,
	request: true,
	requestHandler: getSonarObjectStakeholders
});
